import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Film Décoratif Vitrage Maroc | Intimité & Design – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Film décoratif pour vitrage au Maroc avec UNIK SYSTEM : effet sablé, design personnalisé et protection d’intimité pour bureaux, commerces et espaces modernes."
  );

  setMeta(
    "keywords",
    "film decoratif vitrage maroc, film sablé maroc, film intimité vitre maroc, film vitrage design maroc, sticker vitre maroc, film bureau vitrage maroc, UNIK SYSTEM film decoratif"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/film-decoratif-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Film Décoratif Maroc – Vitrage & Intimité | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Films décoratifs design pour vitrage avec effet sablé et protection d’intimité."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/10Claustra%20d%C3%A9coratif%20architectural%20int%C3%A9rieur%20%E2%80%93%20s%C3%A9paration%20design%20et%20protection%20solaire%20Unik%20System%20Maroc.df54e211f40efc17fc64.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/film-decoratif-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Film Décoratif Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solution design pour vitrage avec intimité et esthétique moderne."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/10Claustra%20d%C3%A9coratif%20architectural%20int%C3%A9rieur%20%E2%80%93%20s%C3%A9paration%20design%20et%20protection%20solaire%20Unik%20System%20Maroc.df54e211f40efc17fc64.webp"
  );

  // ========= SCHEMA (SERVICE DESIGN) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en film décoratif vitrage et solutions d’intimité au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Films Décoratifs",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Film Sablé Vitrage"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Film Intimité Bureau"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-film");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-film";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi un film décoratif vitrage ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est un film adhésif appliqué sur le verre pour ajouter design et intimité."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Protection d’intimité, design moderne, installation rapide et coût réduit."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bureaux, commerces, vitrines et espaces professionnels."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-film");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-film";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;